(ns minorodata.connections.sources.google-sheets-oauth
  (:require [minorodata.app.utils :as app.utils]
            [applied-science.js-interop :as js-interop]))


(def source
  {:id           "google-sheets-oauth"
   :enabled      false
   :name         "Google Sheets oAuth"
   :description  "Google Sheets makes your data pop with colorful charts and graphs"
   :image-source "google-sheets.png"
   :tags         ["data-import"]

   :preview-formatter
   (fn []
     "Authenticated by token")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description bearer-token]} data]
        {:source-type "google-sheets-oauth"
         :name        name
         :description description

         :source
         {:credentials {:type           "service_account"
                        :bearer-token   bearer-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:bearer-token]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :google-sheets-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :oauth
              :label      "Google Sheets oAuth Login"
              :name       :bearer-token
              :required   true

              ;; https://developers.google.com/identity/protocols/oauth2/web-server#httprest
              :request-uri      "https://accounts.google.com/o/oauth2/v2/auth"
              :params-processor (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                  {:response_type response-type
                                   :scope         scope
                                   :client_id     client-id
                                   :redirect_uri  redirect-uri
                                   :state         state})

              :response-processor (fn [response] (:code response))

              :response-type "code"
              :client-id     "30379067571-2evd0d2tn9f12arq7icjmujan4v3mhqg.apps.googleusercontent.com"
              ;; https://developers.google.com/identity/protocols/oauth2/scopes#sheets
              :scope         "https://www.googleapis.com/auth/spreadsheets.readonly"
              :redirect-uri  (str (js-interop/get-in js/window [:location :origin]) "/callback.html")}


             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action spreadsheet workbook destination-table]}]
      {:name          name
       :description   description
       :status        status
       :output-tables []

       :config
       {:extracts [{:spreadsheet       spreadsheet
                    :workbook          workbook
                    :action            action
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:spreadsheet :workbook :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :google-sheets-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "Spreadsheet"
              :name       :spreadsheet
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Workbook"
              :name       :workbook
              :required   true
              :value      ""}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
